import api from "./Api";

export interface ApiResponse<T> {
  result: T;
  isSuccess: boolean;
  message: string;
  statusCode: number;
}

const notification = process.env.REACT_APP_PICKLIST_URL || "";
if (!notification) {
  throw new Error(
    "BASE_URL is undefined. Please set REACT_APP_PICKLIST_URL in your environment variables."
  );
}

const notificationAPI = api(notification);

const getNotification = async (
  notificationData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await notificationAPI.post<ApiResponse<any>>(
      "/api/bellnotification/list",
      notificationData
    );
    const { isSuccess, statusCode, message, result } = response.data;
    return { isSuccess, statusCode, message, result };
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again."
    );
  }
};

const readNotification = async (
  notificationID: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await notificationAPI.put<ApiResponse<any>>(
      "/api/bellnotification/update",
      notificationID
    );
    const { isSuccess, statusCode, message, result } = response.data;
    return { isSuccess, statusCode, message, result };
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again."
    );
  }
};

export { getNotification, readNotification };
